import { Link } from 'react-router-dom';
import Footer from '../Layouts/Footer';
import Canonical from '../../seo/Canonical';
import { customerReviews } from '../../data/customerReviews';
import './OurReviews.css';
import OurReviewsHero from './OurReviewsHero';
import RelatedLinks from '../Common/RelatedLinks';
import { REVIEWS_RELATED_BLOGS } from '../../data/resourcePageRelatedBlogs';

function StarRow({ count }: { count: number }) {
  return (
    <div className="review-card-tp-stars" aria-hidden>
      {Array.from({ length: 5 }).map((_, i) => (
        <svg key={i} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
            opacity={i < count ? 1 : 0.22}
          />
        </svg>
      ))}
    </div>
  );
}

function OurReviews() {
  return (
    <div className="our-reviews-page logistics-page">
      <Canonical baseUrl="https://www.pickpackpro.co.uk" />

      <OurReviewsHero />

      <section className="our-reviews-grid-section" aria-label="Client testimonials">
        <div className="reviews-grid">
          {customerReviews.map((r) => (
            <article key={`${r.name}-${r.company}`} className="review-card-tp">
              <div className="review-card-tp-header">
                <div className="review-card-tp-avatar" style={{ backgroundColor: r.color }}>
                  {r.initials}
                </div>
                <div className="review-card-tp-who">
                  <span className="review-card-tp-name">{r.name}</span>
                  <span className="review-card-tp-company">{r.company}</span>
                </div>
                <span className="review-card-tp-verified">Verified</span>
              </div>
              <StarRow count={r.stars} />
              <p className="review-card-tp-text">{r.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="our-reviews-cta">
        <Link to="/contact-fulfillment-services" className="btn-reviews-cta">
          Start Your Fulfilment Journey with Pick Pack Pro
        </Link>
        <p className="our-reviews-source-note">
          Join brands that trust our Milton Keynes centre for eCommerce fulfilment,{' '}
          <Link to="/blog/amazon-fba-prep-service-uk">Amazon FBA prep</Link>,{' '}
          <Link to="/blog/seller-fulfilled-prime-fulfilment-uk">Seller Fulfilled Prime</Link> and{' '}
          <Link to="/blog/multi-channel-fulfilment-uk">multi-channel fulfilment</Link>. When vetting a
          partner, use{' '}
          <Link to="/blog/how-to-choose-fulfillment-partner">
            how to choose a UK fulfilment partner
          </Link>
          , compare{' '}
          <Link to="/blog/best-3pl-features-for-brands">best 3PL features for brands</Link>, and read{' '}
          <Link to="/blog/pick-pack-pro-vs-diy-fba-prep">Pick Pack Pro vs DIY FBA prep</Link>.
        </p>
      </section>

      <RelatedLinks
        title="Guides from brands who outsourced fulfilment"
        serviceLinks={REVIEWS_RELATED_BLOGS}
        blogLink={{ to: '/fulfillment-blog', label: 'All fulfilment blog articles' }}
      />

      <Footer />
    </div>
  );
}

export default OurReviews;
